module.exports = __webpack_public_path__ + "static/media/won.b8517e90.wav";